import ImagesMainBannerMobileMarch2025AnnabelThomasWebp from '@/public/images/main-banner/mobile-march-2025/annabel-thomas.webp';
import ImagesMainBannerMobileMarch2025ArdbegMobileWebp from '@/public/images/main-banner/mobile-march-2025/ardbeg_mobile.webp';
import ImagesMainBannerMobileMarch2025BottlesOfTheMonthWebp from '@/public/images/main-banner/mobile-march-2025/bottles-of-the-month.webp';
import ImagesMainBannerMobileMarch2025BuyOrSellWhiskyAndSpiritsWebp from '@/public/images/main-banner/mobile-march-2025/buy-or-sell-whisky-and-spirits.webp';
import ImagesMainBannerMobileMarch2025DownloadTheAppWebp from '@/public/images/main-banner/mobile-march-2025/download-the-app.webp';
import ImagesMainBannerMobileMarch2025SellFasterThanEverWebp from '@/public/images/main-banner/mobile-march-2025/sell-faster-than-ever.webp';
import ImagesMainBannerMobileMarch2025SellFasterV2Webp from '@/public/images/main-banner/mobile-march-2025/sell-faster-v2.webp';
import ImagesMainBannerMobileMarch2025TheTimelessDistilleryWebp from '@/public/images/main-banner/mobile-march-2025/the-timeless-distillery.webp';
import ImagesMainBannerMobileMarch2025WinABottleEachMonthWebp from '@/public/images/main-banner/mobile-march-2025/win-a-bottle-each-month.webp';
import ImagesMainBannerMobileMarch2025WinThisBottleWebp from '@/public/images/main-banner/mobile-march-2025/win-this-bottle.webp';

export {
  ImagesMainBannerMobileMarch2025AnnabelThomasWebp,
  ImagesMainBannerMobileMarch2025ArdbegMobileWebp,
  ImagesMainBannerMobileMarch2025BottlesOfTheMonthWebp,
  ImagesMainBannerMobileMarch2025BuyOrSellWhiskyAndSpiritsWebp,
  ImagesMainBannerMobileMarch2025DownloadTheAppWebp,
  ImagesMainBannerMobileMarch2025SellFasterThanEverWebp,
  ImagesMainBannerMobileMarch2025SellFasterV2Webp,
  ImagesMainBannerMobileMarch2025TheTimelessDistilleryWebp,
  ImagesMainBannerMobileMarch2025WinABottleEachMonthWebp,
  ImagesMainBannerMobileMarch2025WinThisBottleWebp,
};
